import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { AllRoutes } from "./routes/AllRoutes";
import { useTranslation } from 'react-i18next';
import { getCookieLang } from './utils/lang';
import { setRedirect } from "./utils/redirect";
import { createTheme, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css"; 
const theme = createTheme({
  typography: {
    fontFamily: 'var(--default-font)', // use the CSS variable here as a string
  },
  palette: {
    primary: {
      main: "#702E8F", // Your custom color
      // You can also specify light/dark/contrastText if needed
      // light: purple[300],
      // dark: purple[700],
      // contrastText: '#fff',
    },
    // You can customize other palette colors too
    secondary: { main: '#4F4F4F' },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "var(--bs-border-color)",
          },
          "&:hover fieldset": {
            borderColor: "var(--bs-border-color)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "var(--bs-border-color)",
          },
        },
      },
    },
  },
});



function App() {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const cookieLang = getCookieLang();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.document.dir = i18n.dir();
  }, [i18n, cookieLang]);

  useEffect(() => {
    setRedirect((path, opts) => navigate(path, opts));
  }, [navigate, location]);

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer 
        position="top-center" 
        autoClose={3000}
        rtl={isAr} 
        draggable
      />
      <div>
        <AllRoutes />
    </div>
    </ThemeProvider>
    
  );
}

export default App;
